import { Component } from "react"
import PropTypes from "prop-types"
import isEmpty from "lodash/isEmpty"
import find from "lodash/find"
import EndpointTestAssertions from "partners/components/endpoint_test/assertions"
import EndpointTestCaseMessage from "partners/components/endpoint_test/test_case_message"

export default class AuthenticationTestRetrieveAuthCode extends Component {
  constructor(props) {
    super(props)
    this.state = {
      assertions: this.setAssertions(),
      callbackUrl: window.location.href.split("?")[0],
      isShowing: false,
      request: this.setRequest(),
      response: this.setResponse(),
    }
    this.getStatusClass = this.getStatusClass.bind(this)
    this.toggle = this.toggle.bind(this)
  }

  componentDidMount() {
    if (this.isRedirect()) {
      window.dispatchEvent(
        new CustomEvent("statusReceived", {
          detail: {
            componentKey: "retrieveAuthCode",
            componentStatus: this.getStatusClass(),
          },
        })
      )
    }
  }

  isRedirect() {
    return !!this.props.auth.state_valid
  }

  setAssertions() {
    if (this.isRedirect()) {
      return {
        code_provided: {
          slug: "code_provided",
          label: "Code was provided",
          status:
            this.props.auth.code && this.props.auth.code.length
              ? "passing"
              : "failing",
        },
        state_matches: {
          slug: "state_matches",
          label: "State matches original state from request",
          status: this.props.auth.state_valid === "1" ? "passing" : "failing",
        },
      }
    }
    return {}
  }

  setRequest() {
    if (this.isRedirect()) {
      return {
        query: {
          client_id: this.props.service.oauth_client_id,
          response_type: "code",
          redirect_uri: this.props.service.redirection_url,
          scope: this.props.auth.scope,
          state: this.props.auth.expected_state,
        },
        url: this.props.service.oauth_authorization_url,
      }
    }
    return null
  }

  setResponse() {
    if (this.isRedirect()) {
      return {
        parameters: {
          code: this.props.auth.code,
          state: this.props.auth.state,
        },
      }
    }
    return null
  }

  getStatusClass() {
    if (this.state.assertions && !isEmpty(this.state.assertions)) {
      return find(
        this.state.assertions,
        assertion => assertion.status === "failing"
      )
        ? "failing"
        : "passing"
    }
    return ""
  }

  testResults() {
    return (
      <div>
        <EndpointTestCaseMessage message={this.state.request} type="request" />
        <EndpointTestCaseMessage
          message={this.state.response}
          type="response"
        />
        <EndpointTestAssertions assertions={this.state.assertions} />
      </div>
    )
  }

  toggle() {
    this.setState({ isShowing: !this.state.isShowing })
  }

  render() {
    const statusClass = this.getStatusClass()
    let mainSection = null
    if (this.state.isShowing && this.isRedirect()) {
      mainSection = this.testResults()
    }
    return (
      <div
        className={`endpoint publish-item ${statusClass} ${
          this.state.isShowing ? "expanded" : "collapsed"
        }`}
      >
        <header onClick={this.toggle}>Retrieve authorization code</header>
        {this.state.isShowing ? mainSection : null}
      </div>
    )
  }
}

AuthenticationTestRetrieveAuthCode.propTypes = {
  auth: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  service: PropTypes.object.isRequired,
}
